import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import useUTMTracking from "./hooks/useUTMTracking";
import "./App.css";

function UTMTracker() {
  useUTMTracking();
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <UTMTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
